import { render } from "./WithdrawalRequests.vue?vue&type=template&id=12f40c74&ts=true"
import script from "./WithdrawalRequests.vue?vue&type=script&lang=ts"
export * from "./WithdrawalRequests.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__